<template>
<div class="cardlist">
        <span class="listmenu">
          <span  v-for="(item,index) of titleparam.MenuList" :key="index" @click="clickmenu(item.code)" :class="menucheck==item.code?'ListbRactive':''">{{item.name}}</span>
        </span>
        <span :style="titleparam.isZBCG!='2'?'display: block;max-height: 414.5px;':'display: block;max-height: 356px;'">
          <span class="listbmenu">
            <span v-for="(item,index) of titleparam.TopMenuList" :key="index" @click="clicktop(item.code)" :class="top==item.code?'topRactive':''">{{item.name}}</span>
            <router-link v-if="titleparam.isZBCG!='2'" to="/list?type=2&class=3&noticeType=21" style="font-size: 13px;color: #8C8C8C;font-weight: 400;text-decoration: none;float:right;margin-right: 36px;margin-top: 20px">更多 >></router-link>
            <router-link v-else to="/list?type=99&class=3&noticeType=21" style="font-size: 13px;color: #8C8C8C;font-weight: 400;text-decoration: none;float:right;margin-right: 36px;margin-top: 20px">更多 >></router-link>
          </span>
          <span :class="titleparam.isZBCG!='2'?'listb':'listbty'" :key="Refresh">
            <span  :class="titleparam.isZBCG!='2'?'listbinformation':'listbinformation2'" v-for="(item,index) of List" :key="index">
              <span style="color: #8C8C8C;">✦</span>
              <router-link style="text-decoration:none;color:unset" :to="titleparam.isZBCG != '2'?(item.autoId==''?menucheck!=22?'/detail?type=1&prjId='+item.prjId:'/detail?type=10&prjId='+item.prjId:'/detail?bulletinId='+item.autoId):('/detail?type=99&articleId=' + item.autoId)">
              <span class="listbtype">{{ titleparam.isZBCG != '2'?('【' + (item.infoTypeId == "D01"
                          ? "货物"
                          : item.infoTypeId == "D02"||item.infoTypeId == "D05"||item.infoTypeId == "D06"
                          ? "工程"
                          : item.infoTypeId == "D03"
                          ? "服务"
                          : "其他") + '】'):'' }}</span>
              <span class="listbid">{{item.prjNo}}</span>
              <span class="listbtitle">{{item.bulletinTitle}}</span>
              </router-link>
              <span class="listbdate">{{ GetDate(item.publishDate) }}</span>
            </span>
          </span>
        </span>
      </div>
</template>

<script>
import {
  GetBulletinList,
  GetBulletinTyList
} from '@/api/Home'
export default {
  name: 'card-list',
  props: {
    titleparam: {
      type: Object,
      default () {
        return {
          MenuList: [],
          TopMenuList: [],
          isZBCG: '0'
        }
      }
    }
  },
  data () {
    return {
      top: '',
      menucheck: '',
      Refresh: 0,
      List: []
    }
  },
  methods: {
    GetDate (date) {
      var day = ''
      if (date) {
        day = date.slice(0, 10)
      }
      return day
    },
    clicktop (code) {
      this.top = code
      this.ChangeBulletinList()
    },
    clickmenu (code) {
      this.menucheck = code
      this.ChangeBulletinList()
    },
    ChangeBulletinList () {
      console.log(this.titleparam.isZBCG)
      let Bulletparam = {
        InfoTypeId: this.top,
        classID: this.menucheck,
        pageIndex: 1,
        pageSize: 8,
        isZBCG: this.titleparam.isZBCG
      }
      var _this = this
      console.log(this.titleparam.isZBCG)
      if (this.titleparam.isZBCG !== '2') {
        GetBulletinList(Bulletparam).then((res) => {
          _this.List = res.data.bulletinList
          _this.Refresh++
        })
      } else {
        console.log(123321)
        GetBulletinTyList(Bulletparam).then((res) => {
          _this.List = res.data.bulletinList
          _this.Refresh++
        })
      }
    }
  },
  mounted () {
    this.top = this.titleparam.TopMenuList[0].code
    this.menucheck = this.titleparam.MenuList[0].code
    this.ChangeBulletinList()
  }
}
</script>

<style scoped>
.cardlist{
    width: 1393px;
    margin: auto;
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
}
.listmenu{
    float: left;
    width: 201px;
    border-right: 1px solid #e7e7e7;
}
.listmenu>span{
    display: inline-block;
    width: 201px;
    /* height: 82px; */
    /* height: 68.3px; */
    height: 58.5px;
    background: #F8F8F8;
    font-size: 17px;
    font-weight: 400;
    color: #353A45;
    /* line-height: 83px; */
    /* line-height: 68.3px; */
    line-height: 58.5px;
    cursor: pointer;
    border-bottom: 1px solid #e7e7e7;
}
.listbmenu{
    display: inline-block;
    width: calc(100% - 206px);
    height: 60px;
    text-align: left;
    border-bottom: 1px dashed #8C8C8C;
}
.listbmenu>span{
    display: inline-block;
    text-align: center;
    width: 168px;
    height: 60px;
    font-size: 17px;
    font-weight: 600;
    color: #353A45;
    line-height: 60px;
    cursor: pointer;
}
.listb {
    display: inline-block;
    width: calc(100% - 203px);
    height: 353.5px;
}
.listbty{
    display: inline-block;
    width: calc(100% - 203px);
    height: 295px;
}
.listbinformation{
    height: 44.2px;
    display: inline-block;
    width: calc(100% - 33px);
    text-align: left;
    /* font-size: 13px; */
    font-size: 14px;
    font-family: ZapfDingbatsITC;
    line-height: 44.2px;
    margin-left: 33px;
}
.listbinformation2{
    height: 36.2px;
    display: inline-block;
    width: calc(100% - 33px);
    text-align: left;
    /* font-size: 13px; */
    font-size: 14px;
    font-family: ZapfDingbatsITC;
    line-height: 36.2px;
    margin-left: 33px;
}
.listbtype{
    color: #C19030;
}
.listbid{
    margin-right: 10px;
    font-weight: 400;
}
.listbtitle{
    display: inline-block;
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
.listbtitle,.listbdate{
    font-weight: 400;
}
.listbdate{
    float: right;
    margin-right: 40px;
}
.ListbRactive{
    background: #175EC6!important;
    color: #FFFFFF!important;
}
.topRactive{
    color: #2578E0!important;
}
</style>>



// WEBPACK FOOTER //
// src/components/cardlist/index.vue